import { setOnSiteEvents, setOnSiteEventsError, setOnSitesEventsFetching } from './actions';
import { call, put, takeLatest } from 'redux-saga/effects';

import { ApiResponse } from 'apisauce';
import { HealAPI } from '../../../healApi';
import { OnSite } from './types';

export function* fetchAllOnSiteEvents() {
  yield put(setOnSitesEventsFetching(true));
  const response: ApiResponse<OnSite[]> = yield call(HealAPI.fetchAllOnSites);
  if (response.ok && response.data) {
    yield put(setOnSiteEvents(response.data));
  } else {
    yield put(setOnSiteEventsError('Failed to retrieve all On Sites'));
  }
  yield put(setOnSitesEventsFetching(false));
}

export function* removeError() {
  yield put(setOnSiteEventsError(''));
}

export function* onSiteEventsFlow() {
  yield takeLatest(['PAGE_DID_MOUNT/OnSites', 'PAGE_DID_MOUNT/CreateVisit'], fetchAllOnSiteEvents);
  yield takeLatest(['PAGE_WILL_UNMOUNT/OnSitePanel'], removeError);
}
